var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrustaceansIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.401,
    height: 72.496,
    viewBox: "0 0 72.401 72.496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.469 -13.515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.577,42.016c8.082,2.931,13.36,7.794,13.36,17.814,0,8.962-16.293,18.928-22.267,18.928S25.4,68.792,25.4,59.83c0-10.02,4.335-14.818,12.247-17.814",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.392,56.49a7.258,7.258,0,0,1-7.237-7.237h0c0-3.98,3.34-7.237,6.68-7.237",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.515,50.923h-6.68a4.467,4.467,0,0,1-4.454-4.453h0a4.467,4.467,0,0,1,4.454-4.454",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.947,56.49a7.258,7.258,0,0,0,7.237-7.237h0c0-3.98-3.34-7.237-6.68-7.237",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.824,50.923H75.5a4.466,4.466,0,0,0,4.454-4.453h0A4.467,4.467,0,0,0,75.5,42.016",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.845,62.057a7.259,7.259,0,0,0-7.237,7.237h0c0,3.98,3.34,7.237,6.68,7.237",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.288,67.624a4.466,4.466,0,0,0-4.453,4.453h0a4.466,4.466,0,0,0,4.453,4.454",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.494,62.057a7.259,7.259,0,0,1,7.237,7.237h0c0,3.98-3.34,7.237-6.68,7.237",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.051,67.624A4.466,4.466,0,0,1,75.5,72.077h0a4.466,4.466,0,0,1-4.453,4.454",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.422,84.325a5.584,5.584,0,0,1-5.567-5.567h0c0-3.062,2.227-5.567,4.454-5.567",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.422,84.325h0a2.784,2.784,0,0,1-2.783-2.784h0a2.783,2.783,0,0,1,2.783-2.783",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.917,84.325a5.583,5.583,0,0,0,5.567-5.567h0c0-3.062-2.227-5.567-4.454-5.567",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.917,84.325h0A2.784,2.784,0,0,0,62.7,81.541h0a2.783,2.783,0,0,0-2.783-2.783",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.34,
    cy: 3.34,
    r: 3.34,
    transform: "translate(49.896 37.563)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.34,
    cy: 3.34,
    r: 3.34,
    transform: "translate(37.649 37.563)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.742,39.789a12.247,12.247,0,0,1-1.113-24.444",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.629,27.542H29.3a6.141,6.141,0,0,1,6.123,6.124h0",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.742,27.542h0a3.34,3.34,0,0,0,3.34-3.34V18.635h0a6.68,6.68,0,0,1,6.68,6.68v1.114",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.185,27.542a6.123,6.123,0,0,1,0-12.247",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6,39.789A12.247,12.247,0,0,0,67.71,15.345",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.71,27.542H66.04a6.141,6.141,0,0,0-6.123,6.124h0",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6,27.542h0a3.34,3.34,0,0,1-3.34-3.34V18.635h0a6.68,6.68,0,0,0-6.68,6.68v1.114",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.154,27.542a6.123,6.123,0,0,0,0-12.247",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.372
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrustaceansIcon);
export default __webpack_public_path__ + "static/media/crustaceans-icon.cf8e90da.svg";
export { ForwardRef as ReactComponent };